import { render } from "./gxxg.vue?vue&type=template&id=b1475604&scoped=true&ts=true"
import script from "./gxxg.vue?vue&type=script&lang=ts"
export * from "./gxxg.vue?vue&type=script&lang=ts"

import "./gxxg.vue?vue&type=style&index=0&id=b1475604&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1475604"]])

export default __exports__